import { css } from "@emotion/css";
import React from "react";

import { Text } from "../../foundations/typography/Text";
import { useColors } from "../../hooks/useColors";
import { ButtonGroup } from "../button/ButtonGroup";
export interface SummaryCardProps {
  header: string | React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  testID?: string;
  className?: string;
  noBorder?: boolean;
  noHeaderBorder?: boolean;
}

export function SummaryCard({
  header,
  children,
  actions,
  testID = "summary-card",
  className,
  noBorder,
  noHeaderBorder,
}: SummaryCardProps) {
  const colors = useColors();
  return (
    <div
      className={css(
        styles.summaryCardWrapper,
        {
          background: "var(--background-base)",
          border: !noBorder ? `1px solid ${colors["border-base"]}` : undefined,
        },
        className
      )}
      data-testid={testID}
    >
      <div
        className={css(styles.headerWrapper, {
          ":not(:last-child)": css({
            borderBottom: !noHeaderBorder
              ? `1px solid ${colors["border-base"]}`
              : "undefined",
          }),
        })}
      >
        <Text
          as="h2"
          style="form/section-heading"
          className={css({
            marginTop: "var(--space-0)",
            marginBottom: "var(--space-0)",
          })}
        >
          {header}
        </Text>
        {actions && <ButtonGroup>{actions}</ButtonGroup>}
      </div>
      {children}
    </div>
  );
}

const styles = {
  alignCenter: css({
    display: "flex",
    alignItems: "center",
  }),
  summaryCardWrapper: css({
    borderRadius: "var(--border-radius-2)",
    marginBottom: "var(--space-4)",
    overflow: "hidden",
  }),
  headerWrapper: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "var(--space-3)",
    paddingRight: "var(--space-4)",
    paddingBottom: "var(--space-3)",
    paddingLeft: "var(--space-4)",
  }),
  outerContentItem: css({
    justifyContent: "space-between",
  }),
};
